import { render, staticRenderFns } from "./EditTariffDialog.vue?vue&type=template&id=7e35f210"
import script from "./EditTariffDialog.vue?vue&type=script&lang=ts"
export * from "./EditTariffDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports